import { Component, Input, OnInit } from '@angular/core';
import { WindowrefService } from '../../services/windowref/windowref.service';
import { NgStyle } from '@angular/common';
import { IonicModule } from '@ionic/angular';

/**
 * Generated class for the PillarsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./pillars.scss'],
    selector: 'pillars',
    templateUrl: 'pillars.html',
    standalone: true,
    imports: [IonicModule, NgStyle]
})
export class PillarsComponent implements OnInit {
  @Input() data;
  @Input() bottomBorder;
  isDarkMode;

  constructor(
    public windowRef: WindowrefService,
  ) { }

  ngOnInit() {
    this.isDarkMode = this.windowRef.isDarkMode();
    if (this.isDarkMode && this.data.firstCol.img == 'assets/imgs/homepage/graphic-affordable2.svg') {
      this.data.firstCol.img = 'assets/imgs/homepage/graphic-affordable2-darkmode.svg'
    }
  }
}
